var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.54671 6.49968L11.8339 0.410312C12.4041 -0.141979 13.3326 -0.141979 13.9028 0.410312C14.473 0.962604 14.473 1.86185 13.9028 2.41414L6.57752 9.50188C6.00729 10.0542 5.07883 10.0542 4.5086 9.50188L0.429251 5.55087C-0.148292 4.9915 -0.148292 4.09934 0.429251 3.54704C1.00679 2.99475 1.92794 2.99475 2.49817 3.54704L5.54671 6.49968Z","fill":"currentColor"}));
}

Tick.defaultProps = {"width":"15","height":"10","viewBox":"0 0 15 10","fill":"none"};

module.exports = Tick;

Tick.default = Tick;
